import { styled } from "@mui/material/styles";
// types
import type { CSSProperties, MouseEventHandler, ReactNode } from "react";

type Props = Readonly<{
	children: ReactNode;
	className?: string;
	style?: CSSProperties;
	onClick?: MouseEventHandler<HTMLDivElement>;
}>;

const ListItemContainer = ({ children, className = undefined, style = undefined, onClick = undefined }: Props) => (
	<div className={className} style={style} onClick={onClick}>
		{children}
	</div>
);

const ListItemContainerStyled = styled(ListItemContainer, { name: "ListItemContainer" })({
	display: "inline-flex",
	justifyContent: "flex-end",
	alignItems: "center",
});

export default ListItemContainerStyled;
